import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ASSETS } from "@/lib/assets";

// Premium marble divider — used sparingly as a section transition.
export const MarbleBreak = ({ label = "Design · Build · Deliver" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="marble-break" className="relative h-56 md:h-72 overflow-hidden border-y border-white/8">
      <motion.img
        src={ASSETS.marble}
        alt=""
        aria-hidden="true"
        style={{ y }}
        className="absolute inset-0 w-full h-[124%] object-cover"
      />
      <div className="absolute inset-0 bg-evo-black/55" />
      <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at center, rgba(5,5,5,0) 25%, rgba(5,5,5,0.8) 100%)" }} />
      <div className="relative z-10 h-full flex flex-col items-center justify-center gap-4 text-center px-6">
        <span className="text-evo-gold text-2xl" aria-hidden="true">✦</span>
        <p className="font-serif italic text-2xl md:text-4xl text-evo-pearl tracking-wide">{label}</p>
      </div>
    </section>
  );
};
